<template>
  <div class="outer-box max-w-xl">
    <h4>Sending Limit Features</h4>

    <b-alert show variant="info" class="text-left m-3">
      Update location limit for SMS/Voicemail. Please verify that the location is A2P approved in
      case of SMS before increasing the Limit and verify the traffic they are sending.
    </b-alert>

    <div class="inner-box" style="text-align: left; width: 500px">
      <select class="hl_input--wrap" type="text" v-model="feature">
        <!-- <option value="email">Email</option> -->
        <option value="sms">SMS</option>
        <option value="voicemail">Voicemail</option>
      </select>
      <input
        class="mt-4 hl_input--wrap"
        type="text"
        placeholder="Location ID"
        v-model="locationId"
      />
      <input
        class="mt-4 hl_input--wrap"
        type="number"
        @keypress="isNumber($event)"
        min="1"
        max="250000"
        placeholder="Limit"
        v-model="limit"
      />
      <div class="errorMsg" v-if="errorMsg">
        <p>{{ errorMsg }}</p>
      </div>
      <button
        class="btn btn-primary mt-4"
        @click="adjustSendingLimit"
        :disabled="!locationId || !limit || isLoading"
      >
        <moon-loader v-if="isLoading" :loading="true" size="21px" color="#fafafa" />
        <span v-else class="capitalize">Sending Limit</span>
      </button>
      <pre v-if="response" style="background-color: #f2f7fa; padding: 16px; margin-top: 16px">{{
        response
      }}</pre>
    </div>
  </div>
</template>

<script>
import { ISVService } from "@/services";
import ConversationsService from "@/services/ConversationsService";
import SpmAppengineService from "@/services/SpmAppengineService";
import config from "@/config";
export default {
  name: "enable-blocked-features",
  data() {
    return {
      locationId: "",
      limit: "",
      feature: "email",
      response: null,
      isLoading: false,
      errorMsg: "",
    };
  },
  methods: {
    async adjustSendingLimit() {
      if (this.limit <= 0 || this.limit > 250000) {
        this.errorMsg = "sending limit must be between 1-250000";
        return;
      }
      this.errorMsg = "";
      this.isLoading = true;
      if (this.feature === "sms" || this.feature === "voicemail") {
        try {
          this.response = await SpmAppengineService.sendingLimit(
            this.feature,
            this.locationId,
            this.limit
          );
          this.isLoading = false;
        } catch (err) {
          this.response = err.response
            ? err.response.data.message || err.response.data.msg
            : err.message || err.msg;
          this.isLoading = false;
        }
      } else {
        try {
          this.response = await ConversationsService.sendingLimit(
            this.feature,
            this.locationId,
            this.limit
          );
          this.isLoading = false;
        } catch (err) {
          this.response = err.response
            ? err.response.data.message || err.response.data.msg
            : err.message || err.msg;
          this.isLoading = false;
        }
      }
    },
    isNumber(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
  },
};
</script>

<style scoped>
.capitalize {
  text-transform: capitalize;
}
.errorMsg {
  color: red;
  font-size: 15px;
  padding-top: 5px;
}
</style>
